export const reportCanvasSliceName = "reportCanvas"

export const REPORT_AUTOSAVE_DEBOUNCE_MS = 1500
